import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import AdvisoryBoardService from "./AdvisoryBoardService";


export const getAdvisoryBoards = createAsyncThunk("AdvisoryBoard/get-AdvisoryBoards", async (thunkAPI) => {
  try {
    return await AdvisoryBoardService.getAdvisoryBoards();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createAdvisoryBoard = createAsyncThunk(
  "AdvisoryBoard/create-AdvisoryBoards",
  async (AssociationData, thunkAPI) => {
    try {
      return await AdvisoryBoardService.createAdvisoryBoard(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAdvisoryBoard = createAsyncThunk(
  "AdvisoryBoard/get-AdvisoryBoard",
  async (id, thunkAPI) => {
    try {
      return await AdvisoryBoardService.getAdvisoryBoard(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAdvisoryBoard = createAsyncThunk(
  "AdvisoryBoard/update-AdvisoryBoard",
  async (id, thunkAPI) => {
    try {
      return await AdvisoryBoardService.updateAdvisoryBoard(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAdvisoryBoard = createAsyncThunk(
  "AdvisoryBoard/delete-AdvisoryBoard",
  async (id, thunkAPI) => {
    try {
      return await AdvisoryBoardService.deleteAdvisoryBoard(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  AdvisoryBoards: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "AdvisoryBoard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdvisoryBoards.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAdvisoryBoards.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.AdvisoryBoards = action.payload.data;
      })
      .addCase(getAdvisoryBoards.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createAdvisoryBoard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createAdvisoryBoard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdAdvisoryBoard = action.payload;
      })
      .addCase(createAdvisoryBoard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })

      .addCase(getAdvisoryBoard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAdvisoryBoard.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.chaptersname= action.payload.data.name;
        state.chapterspost= action.payload.data.post;
        state.chaptersabout= action.payload.data.about;
      })
      .addCase(getAdvisoryBoard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAdvisoryBoard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAdvisoryBoard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedAdvisoryBoard = action.payload;
      })
      .addCase(updateAdvisoryBoard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAdvisoryBoard.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAdvisoryBoard.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedAdvisoryBoard = action.payload;
      })
      .addCase(deleteAdvisoryBoard.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
